export const TOWN_PAGES = [
  {
    name: "Hamilton",
    intro: [
      "Hamilton is our home base, so we know the town and the people who run businesses here. From shops on Quarry Street to tradespeople working across the town, we build websites that help Hamilton businesses get found on Google and win more customers.",
      "Every site is designed from scratch, works perfectly on mobile and is set up for local search, so people searching for your services in Hamilton find you first.",
    ],
    nearby: ["Blantyre", "Bothwell", "Larkhall", "East Kilbride"],
  },
  {
    name: "Motherwell",
    intro: [
      "We design and build websites for Motherwell businesses of every size — from sole traders and salons to established local firms. You get a local web designer you can actually meet, with clear, fixed prices from the start.",
      "We also manage social media for Motherwell businesses, so your website and your Facebook, Instagram and TikTok all work together to bring in enquiries.",
    ],
    nearby: ["Wishaw", "Bellshill", "Hamilton", "Airdrie"],
  },
  {
    name: "Wishaw",
    intro: [
      "Wishaw businesses deserve a website that looks as good as the big brands — without the big-brand price. Our websites start from just £99 and are built to show up when local customers search on Google.",
      "Whether you need a simple 2 page site, a full business website or an online shop, we handle the design, build and setup for you.",
    ],
    nearby: ["Motherwell", "Bellshill", "Hamilton", "Larkhall"],
  },
  {
    name: "East Kilbride",
    intro: [
      "East Kilbride has a busy business community, and standing out online matters. We create modern, fast websites and online shops for East Kilbride businesses that turn visitors into enquiries and sales.",
      "As a local Lanarkshire web designer, we can meet in person, learn how your business works and build a site that fits — then help keep it up to date.",
    ],
    nearby: ["Hamilton", "Blantyre", "Bothwell", "Larkhall"],
  },
  {
    name: "Bothwell",
    intro: [
      "We build stylish, professional websites for Bothwell businesses — from cafés and boutiques to consultants and trades. Every site is mobile-friendly and set up so local customers can find you on Google.",
      "Pair your new website with our social media management to keep your Bothwell business in front of customers every week.",
    ],
    nearby: ["Hamilton", "Blantyre", "Bellshill", "Motherwell"],
  },
  {
    name: "Blantyre",
    intro: [
      "Blantyre businesses can get a professional website from just £99. We design, build and launch your site, then make sure it shows up when people in Blantyre search for what you do.",
      "Need more than a simple site? We also build business websites and online shops, and can run your social media too.",
    ],
    nearby: ["Hamilton", "East Kilbride", "Bothwell", "Larkhall"],
  },
  {
    name: "Bellshill",
    intro: [
      "We help Bellshill businesses look great online with modern websites that work on every phone, tablet and computer. Clear pricing, no jargon and a local designer you can talk to.",
      "From new websites to redesigns of tired old sites, we'll build something that brings Bellshill customers to your door.",
    ],
    nearby: ["Motherwell", "Bothwell", "Coatbridge", "Hamilton"],
  },
  {
    name: "Larkhall",
    intro: [
      "Larkhall tradespeople and local businesses get simple, professional websites from us — built quickly and priced fairly. Your customers can find you, see your work and get in touch in seconds.",
      "We set each site up for local Google searches, so people looking for your services in Larkhall find you, not your competitors.",
    ],
    nearby: ["Hamilton", "Blantyre", "Wishaw", "East Kilbride"],
  },
  {
    name: "Coatbridge",
    intro: [
      "We design websites and handle local SEO for Coatbridge businesses, helping you show up on Google and turn searches into phone calls and enquiries.",
      "Whether you need a quick 2 page website or a full online shop, we take care of everything and keep it simple for you.",
    ],
    nearby: ["Airdrie", "Bellshill", "Motherwell", "Hamilton"],
  },
  {
    name: "Airdrie",
    intro: [
      "Airdrie businesses get modern websites and online shops from a local Lanarkshire designer. We build sites that load fast, look great on mobile and are ready for Google from day one.",
      "Add our social media management and we'll keep your Airdrie business active on Facebook, Instagram and TikTok too.",
    ],
    nearby: ["Coatbridge", "Bellshill", "Motherwell", "Wishaw"],
  },
].map((t) => ({ ...t, slug: `web-design-${t.name.toLowerCase().replace(/\s+/g, "-")}` }));

export const TOWN_REVIEWS = {
  // Hamilton: [{ name: "Jane Smith", business: "JS Plumbing", text: "Andy built our site in a week...", rating: 5 }],
};

export const townPath = (name) => {
  const t = TOWN_PAGES.find((p) => p.name === name);
  return t ? `/${t.slug}` : null;
};
